//#region Old Code

// import React from 'react';
// import request from 'arcdynamic-request';
// import Dropdown from "../Dropdown/Dropdown";
// import PropTypes from "prop-types";

// class SelectTeamMember extends React.Component {
//     constructor(props) {
//         super(props);

//         this.state = {
//             items: [],
//         };
//     }

//     componentDidMount() {
//          request(arc.path.api, {
//             service: 'arcimedes',
//             action: 'open.datasource.table.Data.getData',
//             params: ['code', 'TEAM', {
//                 limit: {
//                     count: 1000,
//                     offset: 0,
//                 },
//                 column: [
//                     'ARCIMEDES_ROW_ID',
//                     'FIRST_NAME',
//                     'LAST_NAME',
//                     'DELETED',
//                     'IS_AGENT',
//                 ],
//                 filter: [
//                     {
//                         code: 'FIRST_NAME',
//                         text: '',
//                         type: 'notNull',
//                     },
//                     {
//                         code: 'LAST_NAME',
//                         text: '',
//                         type: 'notNull',
//                     },
//                 ],
//                 filterType: 'and',
//                 order: [
//                     {
//                         code: 'FIRST_NAME',
//                         type: 'asc',
//                     },
//                     {
//                         code: 'LAST_NAME',
//                         type: 'asc',
//                     },
//                 ],
//             }],
//         }).then(res => {
//             let items = res.data ? res.data.filter(x => x.FIRST_NAME && x.LAST_NAME) : false;           
//             this.setState({items});
//         }); 
//     }

//     render() {
//         const {
//             theme,
//             value,
//             valueKey,
//             percentKey,
//             label,
//             percentLabel,
//             disabled,
//             data,
//             isFilter,
//             handleParentChange,
//             handleInputParentChange,
//             viewMode,
//             deleted,
//             isFromProperty,
//             hasAgentPercent,
//             ...rest
//         } = this.props;
//         const { items } = this.state;
//         const teamMemberList = items && items.filter(x => (x.DELETED === 'n' || x.DELETED === null)) || [];

//         return (
//             <Dropdown theme={theme}
//                       optionsType='team'
//                       optionKey='ARCIMEDES_ROW_ID'
//                       options={teamMemberList}
//                       value={value}
//                       valueKey={valueKey}
//                       percentKey={percentKey}
//                       label={label}
//                       percentLabel={percentLabel}
//                       disabled={!items || disabled}
//                       data={data}
//                       isFilter={isFilter}
//                       groupBy={true && !this.props.onlyActive}
//                       handleParentChange={handleParentChange}
//                       handleInputParentChange={handleInputParentChange}
//                       viewMode={viewMode}
//                       deleted={deleted}
//                       isFromProperty={isFromProperty}
//                       hasAgentPercent={hasAgentPercent}
//                       {...rest}
//             />
//         )
//     }
// }

// SelectTeamMember.propTypes = {
//     theme: PropTypes.oneOf(['default', 'white', 'dark']),
//     value: PropTypes.string,
//     valueKey: PropTypes.string.isRequired,
//     label: PropTypes.string,
//     percentLabel: PropTypes.string,
//     disabled: PropTypes.bool,
//     data: PropTypes.object,
//     handleParentChange: PropTypes.func.isRequired,
//     isFilter: PropTypes.bool,
//     viewMode: PropTypes.bool,
//     groupBy: PropTypes.bool,
//     deleted: PropTypes.bool,
//     isFromProperty: PropTypes.bool,
//     hasAgentPercent: PropTypes.bool,
//     handleInputParentChange: PropTypes.func,
// };

// export default SelectTeamMember;

//#endregion


import React from 'react';
import request from 'arcdynamic-request';
import Dropdown from "../Dropdown/Dropdown";
import PropTypes from "prop-types";
import { ApolloConsumer } from '@apollo/client';
import { GET_TEAMMEMBERS } from '../Graphql/Queries/TeamMemberQuery';
import { fetchData } from '../Service/graphQlService';
import { GET_CONTACT_TEAM_LIST_QUERY } from '../Graphql/ContactsQueries/contactsQuery';

class SelectTeamMember extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
        };
        this.client = null;
    }

    componentDidMount() {

        
            const pageOptions = {
              "page": 1,
              "pageSize": 10000
            }
            const filters =  [
              {}
            ];
            const sortOptions=  [
              {
                "field": "first_name",
                "order": "asc"
              },
              {
                "field": "last_name",
                "order": "asc"
              }
            ]
          
        if(this.client){
            //const token = localStorage.getItem('authToken');
            // this.client.query({query:GET_TEAMMEMBERS, variables:{pageOptions: pageOptions, filters:filters, sortOptions: sortOptions},fetchPolicy: "no-cache",
            // context: {
            //     headers: {
            //         authorization: `Bearer ${token}`, // Bearer token added here
            //     },
            // }})
        //     fetchData(GET_TEAMMEMBERS, {pageOptions: pageOptions, filters:filters, sortOptions: sortOptions})
        //     .then(res => {
        //         let items = res.data.getTeamMembers.teamMember ? res.data.getTeamMembers.teamMember.filter(x => x.first_name && x.last_name) : false;
        //         this.setState({ items });
        //     });
        // }
            fetchData(GET_CONTACT_TEAM_LIST_QUERY, {type:"Team",pageOptions: pageOptions, filters:filters, sortOptions: sortOptions})
            .then(res => {
                let items = res.data.getContacts.data ? res.data.getContacts.data .filter(x => x.first_name && x.last_name) : false;
                this.setState({ items });
            });
        }
        
    }

    render() {
        const {
            theme,
            value,
            valueKey,
            percentKey,
            label,
            percentLabel,
            disabled,
            data,
            isFilter,
            handleParentChange,
            handleInputParentChange,
            viewMode,
            deleted,
            isFromProperty,
            hasAgentPercent,
            ...rest
        } = this.props;
        const { items } = this.state;
        const teamMemberList = items && items.filter(x => (x.deleted === 'n' || x.deleted === null)) || [];

        return (
            <ApolloConsumer>
                {client => {
                    if (!this.client) {
                        this.client = client;
                    }
                    return (
                        <Dropdown theme={theme}
                            optionsType='team'
                            optionKey='arcimedes_row_id'
                            options={teamMemberList}
                            value={value}
                            valueKey={valueKey}
                            percentKey={percentKey}
                            label={label}
                            percentLabel={percentLabel}
                            disabled={!items || disabled}
                            data={data}
                            isFilter={isFilter}
                            groupBy={true && !this.props.onlyActive}
                            handleParentChange={handleParentChange}
                            handleInputParentChange={handleInputParentChange}
                            viewMode={viewMode}
                            deleted={deleted}
                            isFromProperty={isFromProperty}
                            hasAgentPercent={hasAgentPercent}
                            {...rest}
                        />
                    )
                }}
            </ApolloConsumer>

        )
    }
}

SelectTeamMember.propTypes = {
    theme: PropTypes.oneOf(['default', 'white', 'dark']),
    value: PropTypes.string,
    valueKey: PropTypes.string.isRequired,
    label: PropTypes.string,
    percentLabel: PropTypes.string,
    disabled: PropTypes.bool,
    data: PropTypes.object,
    handleParentChange: PropTypes.func.isRequired,
    isFilter: PropTypes.bool,
    viewMode: PropTypes.bool,
    groupBy: PropTypes.bool,
    deleted: PropTypes.bool,
    isFromProperty: PropTypes.bool,
    hasAgentPercent: PropTypes.bool,
    handleInputParentChange: PropTypes.func,
};

export default SelectTeamMember;
